import { render } from "./SkinSlotD.vue?vue&type=template&id=595ae09d&scoped=true&ts=true"
import script from "./SkinSlotD.vue?vue&type=script&lang=ts"
export * from "./SkinSlotD.vue?vue&type=script&lang=ts"

import "./SkinSlotD.vue?vue&type=style&index=0&id=595ae09d&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595ae09d"]])

export default __exports__